export enum PluginType {
  ContentSectionPlugin = 'ContentSectionPlugin',
  TextPlugin = 'TextPlugin',
  TeacherGuidePlugin = 'TeacherGuidePlugin',
  VerticalSpacerPlugin = 'VerticalSpacerPlugin',
  PicturePlugin = 'PicturePlugin',
  CodeBlockPlugin = 'CodeBlockPlugin',
  EmbedBlockPlugin = 'EmbedBlockPlugin',
  HighlightSectionPlugin = 'HighlightSectionPlugin',
  EditorBlockPlugin = 'EditorBlockPlugin',
  InteractiveQuizPlugin = 'InteractiveQuizPlugin',
  YoutubeEmbedPlugin = 'YoutubeEmbedPlugin',
  ConditionalBlockPlugin = 'ConditionalBlockPlugin',
  FileBlockPlugin = 'FileBlockPlugin',
  PresentationBlockPlugin = 'PresentationBlockPlugin',
  AssessmentPlugin = 'AssessmentPlugin',
  InfobipPortalEmbedPlugin = 'InfobipPortalEmbedPlugin',
  TablePlugin = 'TablePlugin',
  GoogleDrivePlugin = 'GoogleDrivePlugin',
  FillPlugin = 'FillPlugin',
  ImageHotspotsPlugin = 'ImageHotspotsPlugin',
  MarkTheWordsPlugin = 'MarkTheWordsPlugin',
  AssociationsPlugin = 'AssociationsPlugin',
  FlipCardPlugin = 'FlipCardPlugin',
  StackLayoutPlugin = 'StackLayoutPlugin',
  GptBlockPlugin = 'GptBlockPlugin',
  AIBlockPlugin = 'AIBlockPlugin',
  HtmlBlockPlugin = 'HtmlBlockPlugin',
  ModalBlockPlugin = 'ModalBlockPlugin',
  TriggerBlockPlugin = 'TriggerBlockPlugin',
}

export interface JsonCmsContent {
  id: string | number;
  plugin: PluginType;
  data: any;
  children: JsonCmsContent[];
}

export interface JsonCmsContentDto {
  results: JsonCmsContent[];
  count: number;
  currentPage: number;
  totalPages: number;
  isPresentation: boolean;
}
